import { render } from "./DashboardView.vue?vue&type=template&id=99658a1e&scoped=true"
import script from "./DashboardView.vue?vue&type=script&lang=js"
export * from "./DashboardView.vue?vue&type=script&lang=js"

import "./DashboardView.vue?vue&type=style&index=0&id=99658a1e&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-99658a1e"

export default script